import React, { FC } from 'react'

interface IICon {
  color?: string
}

const ArrowDown: FC<IICon> = ({ color }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 22.7499C6.07 22.7499 1.25 17.9299 1.25 11.9999C1.25 6.06989 6.07 1.24989 12 1.24989C17.93 1.24989 22.75 6.06989 22.75 11.9999C22.75 17.9299 17.93 22.7499 12 22.7499ZM12 2.74989C6.9 2.74989 2.75 6.89989 2.75 11.9999C2.75 17.0999 6.9 21.2499 12 21.2499C17.1 21.2499 21.25 17.0999 21.25 11.9999C21.25 6.89989 17.1 2.74989 12 2.74989Z"
        fill={color || "#73777F"} />
      <path className="arrow" d="M12.0002 15.01C11.8102 15.01 11.6202 14.94 11.4702 14.79L7.94016 11.26C7.65016 10.97 7.65016 10.49 7.94016 10.2C8.23016 9.90995 8.71016 9.90995 9.00016 10.2L12.0002 13.2L15.0002 10.2C15.2902 9.90995 15.7702 9.90995 16.0602 10.2C16.3502 10.49 16.3502 10.97 16.0602 11.26L12.5302 14.79C12.3802 14.94 12.1902 15.01 12.0002 15.01Z"
        fill={color || "#73777F"} />
    </svg>
  )
}

export default ArrowDown